export default __webpack_public_path__ + "static/media/Join-TheCellar.d1f9aa7f.jpg";